import { render, staticRenderFns } from "./NotificationSystemPrefsForm.vue?vue&type=template&id=7b3a2148&scoped=true"
import script from "./NotificationSystemPrefsForm.vue?vue&type=script&lang=ts"
export * from "./NotificationSystemPrefsForm.vue?vue&type=script&lang=ts"
import style0 from "./NotificationSystemPrefsForm.vue?vue&type=style&index=0&id=7b3a2148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3a2148",
  null
  
)

export default component.exports